import { ReturnRequestLogDto } from "@babackapp/private-api-client/types";
import useTranslation from "@babackapp/translations/use-translation";
import { useCurrentShopSuspense } from "@/api/shops/use-current-shop-suspense.ts";
import { getAuthorName } from "@/pages/(app)/returns/utils/get-author-name.ts";
import ActivityWrapper from "@/pages/(app)/returns/view/components/return-activity/contents/activity-wrapper.tsx";
import ActivityIconWrapper from "@/pages/(app)/returns/view/components/return-activity/contents/activity-icon-wrapper.tsx";
import ActivityContentWrapper from "@/pages/(app)/returns/view/components/return-activity/contents/activity-content-wrapper.tsx";
import { ActivityItemHeader } from "@/pages/(app)/returns/view/components/return-activity/contents/activity-item-header.tsx";
import { CircleDashed } from "lucide-react";

type UpdateDeactivateAutoTreatLogisticianActivityProps = {
  activity: ReturnRequestLogDto;
};

export default function UpdateDeactivateAutoTreatLogisticianActivity({
  activity,
}: UpdateDeactivateAutoTreatLogisticianActivityProps) {
  const t = useTranslation();
  const { data: shop } = useCurrentShopSuspense();

  const author = shop.users.find(
    (user) => user.userId === activity.author,
  )?.user;
  const authorName = getAuthorName(author);

  return (
    <ActivityWrapper>
      <ActivityIconWrapper>
        <CircleDashed className="size-4" />
      </ActivityIconWrapper>
      <ActivityContentWrapper>
        <div className="flex items-center gap-2">
          <ActivityItemHeader title="" timestamp={activity.date}>
            <span className="font-bold">{authorName}</span>
            {t("returnDetail.modifiedDeactivateAutoTreatLogistician.preText")}
            <span className="font-bold">
              {activity.params.deactivateAutoTreatLogistician
                ? t(
                    "returnDetail.modifiedDeactivateAutoTreatLogistician.activated",
                  )
                : t(
                    "returnDetail.modifiedDeactivateAutoTreatLogistician.deactivated",
                  )}
            </span>
            {t("returnDetail.modifiedDeactivateAutoTreatLogistician.postText")}
          </ActivityItemHeader>
        </div>
      </ActivityContentWrapper>
    </ActivityWrapper>
  );
}
